/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Zum Speichern müssen alle Felder ausgefüllt werden.`
};

const en_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `To save, you need to fill in all the fields.`
};

const es_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Para guardar, debes rellenar todos los campos.`
};

const fr_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Pour enregistrer, vous devez remplir tous les champs.`
};

const it_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Per registrarti, è necessario compilare tutti i campi.`
};

const nl_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Om te registreren, moet u alle velden invullen.`
};

const pt_register_car__fill_to_save = /** @type {(inputs: {}) => string} */ () => {
	return `Para guardar, deve preencher todos os campos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__fill_to_save(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__fill_to_save", locale)
	if (locale === "de") return de_register_car__fill_to_save(inputs)
	if (locale === "en") return en_register_car__fill_to_save(inputs)
	if (locale === "es") return es_register_car__fill_to_save(inputs)
	if (locale === "fr") return fr_register_car__fill_to_save(inputs)
	if (locale === "it") return it_register_car__fill_to_save(inputs)
	if (locale === "nl") return nl_register_car__fill_to_save(inputs)
	return pt_register_car__fill_to_save(inputs)
};